import { render, staticRenderFns } from "./ModalAddClass.vue?vue&type=template&id=3db0704c&scoped=true&"
import script from "./ModalAddClass.vue?vue&type=script&lang=ts&"
export * from "./ModalAddClass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0704c",
  null
  
)

export default component.exports